"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMode = exports.Role = void 0;
var Role;
(function (Role) {
    Role["host"] = "host";
    Role["user"] = "user";
})(Role = exports.Role || (exports.Role = {}));
var TeamMode;
(function (TeamMode) {
    TeamMode["Off"] = "off";
    TeamMode["Choose"] = "choose";
    TeamMode["Random"] = "random";
})(TeamMode = exports.TeamMode || (exports.TeamMode = {}));
//# sourceMappingURL=types.js.map